import React from "react";
import AppSignIn from "../../components/AppSignIn";
//import AppSignInOidc from "../../components/AppSignInOidc";
import config from "../../config";
import debug from "../../utils/debug";
import { hasAndIsNotEmpty } from "../../utils/helpers";

const AppAuthSFDC = React.lazy(() => import("../../components/AppAuthSFDC"));
export interface AppAuthProps {
  children: React.ReactNode | React.ReactNodeArray;
}

export default function AppAuth({ children }: AppAuthProps) {
  debug("[AppAuth] brand:", config.id);
  //if (config.services.oidc) {
  //  return <AppSignInOidc>{children}</AppSignInOidc>;
  //} else {
  //return <AppSignIn>{children}</AppSignIn>;
  //}
  return hasAndIsNotEmpty(config, "services.sfdc.Auth") ? (
    <AppAuthSFDC>{children}</AppAuthSFDC>
  ) : (
    <AppSignIn>{children}</AppSignIn>
  );
}
